import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'

export interface ClaimRequestPayload {
  organizationName: string
  pageId: number
  pageType: 'hospital' | 'agency'
  requesterName: string
  requesterTitle?: string
  requesterEmail: string
  proofDocumentation?: {
    additionalNotes?: string
    documentation?: string
    linkedinUrl?: string
    [key: string]: unknown
  }
}

export interface ClaimRequestResponse {
  id: number
  auth0UserId: string
  pageType: 'hospital' | 'agency'
  pageId: number
  organizationName: string
  requesterName: string
  requesterTitle?: string
  requesterEmail: string
  proofDocumentation?: Record<string, unknown>
  status: 'pending' | 'approved' | 'denied'
  reviewedBy?: string | null
  reviewedAt?: string | null
  reviewNotes?: string | null
  createdAt: string
  updatedAt: string
  deletedAt?: string | null
}

export class ClaimPageService {
  /**
   * Submit a claim request for a hospital or agency page
   */
  public async submitClaimRequest(payload: ClaimRequestPayload): Promise<ClaimRequestResponse> {
    const scrubstrApiQueryService = new ScrubstrApiQueryService()

    return await scrubstrApiQueryService.post<ClaimRequestResponse>({
      data: payload,
      endpoint: 'claim-request',
    })
  }
}
